<template>
  <div class="home">
    <CustomerList v-show="listView" @newCustomer="onClickNewFromList" @editCustomer="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <CustomerForm v-show="formView" :customer="customer" @backClicked="onBackChild"/>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomerList from '@/components/customer/CustomerList.vue'
import CustomerForm from '@/components/customer/CustomerForm.vue'
import { mapState } from 'vuex'

export default {
  name: 'Customer',
  components: {
    CustomerList,
    CustomerForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      customer: {
        id: null,
        customer_no: null,
        name: null,
        group_id: null,
        email: null,
        phone: null,
        address: null,
        city_id: null,
        state_id: null,
        area_id: null,
        identity_number: null,
        vat: null,
        birthday: null,
        birthplace: null,
        twitter: null,
        facebook: null,
        instagram: null,
        group: null,
        comany_no: null,
        rating_id: null,
        term_due_id: null,
        active: true,
        rating_auto: false,
        notes: null,
        plafond_type: null,
        plafond_amount: '0',
        sale: [{
          id: null,
          sale_no: null,
          sale_date: null,
          sale_due_date: null,
          age: null,
          type_id: null,
          price_id: null,
          customer_no: null,
          branch_no: null,
          subtotal: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          total_payment: '0',
          outstanding: '0'
        }],
        payment: [{
          id: null,
          sale_no: null,
          payment_no: null,
          payment_date: null,
          price: null,
          method_id: null,
          type_id: null,
          bank_id: null,
          notes: null,
          lock: false,
          journal_code: null,
          status: null,
          prepayment_date: null,
          qroup_no: null,
          account_code: null,
          report_no: null
        }],
        workshop: [{
          type_id: null,
          workshop_no: null,
          start_date: null,
          end_date: null,
          customer_no: null,
          customer_note: null,
          work_order: null,
          notes: null,
          get_backup: null,
          change_part: null,
          engineer_id: null,
          subtotal: '0',
          discount: '0',
          tax_id: null,
          tax: '0',
          total: '0'
        }]
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.customer = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.customer = {
        id: null,
        customer_no: null,
        name: null,
        group_id: 1,
        email: null,
        phone: null,
        address: null,
        city_id: null,
        state_id: null,
        area_id: null,
        identity_number: null,
        vat: null,
        birthday: null,
        birthplace: null,
        twitter: null,
        facebook: null,
        instagram: null,
        group: null,
        company_no: this.authUser.company_no,
        rating_id: 'evaluate',
        term_due_id: 3,
        active: true,
        rating_auto: true,
        notes: null,
        plafond_type: null,
        plafond_amount: '0',
        sale: [{
          id: null,
          sale_no: null,
          sale_date: null,
          sale_due_date: null,
          age: null,
          type_id: null,
          price_id: null,
          customer_no: null,
          branch_no: null,
          subtotal: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          total_payment: '0',
          outstanding: '0'
        }],
        payment: [{
          id: null,
          sale_no: null,
          payment_no: null,
          payment_date: null,
          price: null,
          method_id: null,
          type_id: null,
          bank_id: null,
          notes: null,
          lock: false,
          journal_code: null,
          status: null,
          prepayment_date: null,
          qroup_no: null,
          account_code: null,
          report_no: null
        }],
        workshop: [{
          type_id: null,
          workshop_no: null,
          start_date: null,
          end_date: null,
          customer_no: null,
          customer_note: null,
          work_order: null,
          notes: null,
          get_backup: null,
          change_part: null,
          engineer_id: null,
          subtotal: '0',
          discount: '0',
          tax_id: null,
          tax: '0',
          total: '0'
        }]
      }
    },
    async onBackChild () {
      this.listView = true
      this.formView = false
      this.customer = {
        id: null,
        customer_no: null,
        name: null,
        group_id: null,
        email: null,
        phone: null,
        address: null,
        city_id: null,
        state_id: null,
        area_id: null,
        identity_number: null,
        vat: null,
        birthday: null,
        birthplace: null,
        twitter: null,
        facebook: null,
        instagram: null,
        group: null,
        company_no: null,
        rating_id: null,
        term_due_id: null,
        active: true,
        rating_auto: false,
        notes: null,
        plafond_type: null,
        plafond_amount: '0',
        sale: [{
          id: null,
          sale_no: null,
          sale_date: null,
          sale_due_date: null,
          age: null,
          type_id: null,
          price_id: null,
          customer_no: null,
          branch_no: null,
          subtotal: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          total_payment: '0',
          outstanding: '0'
        }],
        payment: [{
          id: null,
          sale_no: null,
          payment_no: null,
          payment_date: null,
          price: null,
          method_id: null,
          type_id: null,
          bank_id: null,
          notes: null,
          lock: false,
          journal_code: null,
          status: null,
          prepayment_date: null,
          qroup_no: null,
          account_code: null,
          report_no: null
        }],
        workshop: [{
          type_id: null,
          workshop_no: null,
          start_date: null,
          end_date: null,
          customer_no: null,
          customer_note: null,
          work_order: null,
          notes: null,
          get_backup: null,
          change_part: null,
          engineer_id: null,
          subtotal: '0',
          discount: '0',
          tax_id: null,
          tax: '0',
          total: '0'
        }]
      }
      // await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser
    })
  },
  mounted () {
    this.$store.dispatch('getStateList')
    this.$store.dispatch('getCityList')
    this.$store.dispatch('getAreaList')
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getCustomerGroupList')
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getCustomerRating')
    this.$store.dispatch('getTermDueList')
    this.$store.dispatch('getEmployeeList')
  }
}
</script>
